export default function InputBox({
  placeholder,
  setInputValue,
  inputValue,
  err,
  maxLength,
}) {
  return (
    <input
      type="text"
      inputMode="numeric"
      maxLength={maxLength}
      className={`w-full h-[48px] text-center bg-scabWhite rounded-[12px] text-large font-IRANSans font-[700] border outline-none px-3 ${
        err ? "border-scabBlack text-scabBlack" : "border-scabRed text-scabRed"
      }`}
      placeholder={placeholder}
      onChange={(e) => setInputValue(e.target.value.replace(/\D/g, ""))}
      value={inputValue}
    />
  );
}
